import { useMemo, useState } from "react"

import { Badge, Divider, Flex, Tag, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Filters from "../../../../Components/Filters"
import Table from "../../../../Components/Table"

const { Text } = Typography

const mockFilterOptions = {
  alert_status: ["Attention", "Auto-refunded", "Pending"],
  alert_service: ["Ethoca", "RDR", "CDRN"]
}

const mockVisibleFilters = {
  alert_status: true,
  transaction_id: true,
  alert_timestamp: true,
  alert_service: true,
  card_last4: true
}

const mockAllFilters = [
  { field_id: "alert_status", label: "Status" },
  { field_id: "transaction_id", label: "Transaction ID" },
  { field_id: "alert_timestamp", label: "Alert date" },
  { field_id: "alert_service", label: "Alert source" },
  { field_id: "card_last4", label: "Card" }
]

const defaultFilters = {
  alert_status: "all",
  transaction_id: [],
  alert_timestamp: null,
  alert_service: "all",
  card_last4: []
}

const mockAlerts = [
  // {
  //   alert_id: "alt_001",
  //   alert_status: "Attention",
  //   transaction_id: "TXN-1001",
  //   alert_timestamp: "2026-05-21 09:30",
  //   alert_service: "Ethoca",
  //   card_last4: "4242",
  //   amount: "$129.00",
  //   customer_email: "sarah@example.com",
  // },
  // {
  //   alert_id: "alt_002",
  //   alert_status: "Auto-refunded",
  //   transaction_id: "TXN-1002",
  //   alert_timestamp: "2026-05-21 11:10",
  //   alert_service: "RDR",
  //   card_last4: "1881",
  //   amount: "$84.50",
  //   customer_email: "mike@example.com",
  // },
  // {
  //   alert_id: "alt_003",
  //   alert_status: "Pending",
  //   transaction_id: "TXN-1003",
  //   alert_timestamp: "2026-05-20 17:45",
  //   alert_service: "CDRN",
  //   card_last4: "5500",
  //   amount: "$245.00",
  //   customer_email: "olivia@example.com",
  // },
  // {
  //   alert_id: "alt_004",
  //   alert_status: "Auto-refunded",
  //   transaction_id: "TXN-1004",
  //   alert_timestamp: "2026-05-20 13:15",
  //   alert_service: "Ethoca",
  //   card_last4: "9876",
  //   amount: "$61.20",
  //   customer_email: "jack@example.com",
  // },
]

const getStatusColor = (status) => {
  if (status === "Attention") return "error"
  if (status === "Auto-refunded") return "success"
  if (status === "Pending") return "processing"
  return "default"
}

const DigitalAlertsSection = () => {
  const { t } = useTranslation()
  const [filters, setFilters] = useState(defaultFilters)

  const showClearBtn = useMemo(
    () => JSON.stringify(filters) !== JSON.stringify(defaultFilters),
    [filters]
  )

  const filteredAlerts = useMemo(() => {
    return mockAlerts.filter((item) => {
      if (filters.alert_status !== "all" && !filters.alert_status?.includes?.(item.alert_status)) {
        return false
      }

      if (
        filters.alert_service !== "all" &&
        !filters.alert_service?.includes?.(item.alert_service)
      ) {
        return false
      }

      if (filters.transaction_id?.length) {
        const ids = filters.transaction_id.map((value) => value.toLowerCase())
        if (!ids.some((value) => item.transaction_id.toLowerCase().includes(value))) {
          return false
        }
      }

      if (filters.card_last4?.length) {
        const cards = filters.card_last4.map((value) => value.toLowerCase())
        if (!cards.some((value) => item.card_last4.toLowerCase().includes(value))) {
          return false
        }
      }

      return true
    })
  }, [filters])

  const columns = useMemo(
    () => [
      {
        title: t("Status"),
        dataIndex: "alert_status",
        key: "alert_status",
        width: 170,
        render: (value) => (
          <Tag className="simple large" style={{ margin: 0 }}>
            <Flex gap={8} align="center">
              <Badge status={getStatusColor(value)} />
              <Text>{value}</Text>
            </Flex>
          </Tag>
        )
      },
      {
        title: t("Transaction ID"),
        dataIndex: "transaction_id",
        key: "transaction_id",
        width: 160
      },
      {
        title: t("Alert date"),
        dataIndex: "alert_timestamp",
        key: "alert_timestamp",
        width: 170
      },
      {
        title: t("Alert source"),
        dataIndex: "alert_service",
        key: "alert_service",
        width: 140
      },
      {
        title: t("Card"),
        dataIndex: "card_last4",
        key: "card_last4",
        width: 100
      },
      {
        title: t("Order value"),
        dataIndex: "amount",
        key: "amount",
        width: 130
      },
      {
        title: t("Customer email"),
        dataIndex: "customer_email",
        key: "customer_email",
        width: 220
      }
    ],
    [t]
  )

  return (
    <Flex vertical gap={24}>
      <Divider style={{ margin: 0 }} />

      <Flex gap={32} align="center" justify="space-between" style={{ margin: "-4px 0 0" }}>
        <Filters
          visibleFilters={mockVisibleFilters}
          filterOptions={mockFilterOptions}
          allFilters={mockAllFilters}
          filters={filters}
          onChangeFilter={(value) => setFilters((prev) => ({ ...prev, ...value }))}
          showClearBtn={showClearBtn}
          onClearFilters={() => setFilters(defaultFilters)}
        />
      </Flex>

      <Table
        rowKey="alert_id"
        columns={columns}
        dataSource={filteredAlerts}
        loading={false}
        withOutPagination
        scroll={{ x: "max-content" }}
      />
    </Flex>
  )
}

export default DigitalAlertsSection
